export class CoalesceModel {
  constructor(public target = '', public operation: 'GREATEST' | 'LEAST' = 'GREATEST', public columns: string[] = []) {}
}
